import asyncActionTypes from '../actions/types';

const initialState = {
  cause: [],
  code: '',
  errorFromSalesforce: false,
  loading: false,
  message: {},
  messageServer: {},
  status: '',
};

const refundInfoToSalesforce = (state = initialState, action = null / undefined) => {
  switch (action.type) {
    case asyncActionTypes.REFUND_INFO_TO_SALESFORCE.START:
      return {
        ...state,
        loading: true,
      };
    case asyncActionTypes.REFUND_INFO_TO_SALESFORCE.SUCCESS:
      return {
        ...state,
        loading: false,
        messageServer: action.payload,
      };
    case asyncActionTypes.REFUND_INFO_TO_SALESFORCE.FAIL:
      return {
        ...state,
        cause: action.payload.cause,
        code: action.payload.code,
        errorFromSalesforce: true,
        loading: false,
        message: action.payload.message,
        messageServer: action.payload.messageServer,
        status: action.payload.status,
      };
    default:
      return state;
  }
};

export default refundInfoToSalesforce;